import { Action } from '@ngrx/store';
import { type } from '../shared/helpers';

export const ActionTypes = {
    GET_POST_LIST: type('GET_POST_LIST'),
    GET_POST_LIST_SUCCESS: type('GET_POST_LIST_SUCCESS'),
    GET_POST_LIST_FAIL: type('GET_POST_LIST_FAIL'),

    GET_POST_ITEM: type('GET_POST_ITEM'),
    GET_POST_ITEM_SUCCESS: type('GET_POST_ITEM_SUCCESS'),
    GET_POST_ITEM_FAIL: type('GET_POST_ITEM_FAIL'),
    CLEAR_GET_POST_ITEM_STATE: type('CLEAR_GET_POST_ITEM_STATE'),

    REMOVE_POST_ITEM: type('REMOVE_POST_ITEM'),
    REMOVE_POST_ITEM_SUCCESS: type('REMOVE_POST_ITEM_SUCCESS'),
    REMOVE_POST_ITEM_FAIL: type('REMOVE_POST_ITEM_FAIL'),
    CLEAR_REMOVE_POST_ITEM_STATE: type('CLEAR_REMOVE_POST_ITEM_STATE'),

    CREATE_POST_ITEM: type('CREATE_POST_ITEM'),
    CREATE_POST_ITEM_SUCCESS: type('CREATE_POST_ITEM_SUCCESS'),
    CREATE_POST_ITEM_FAIL: type('CREATE_POST_ITEM_FAIL'),
    CLEAR_CREATE_POST_ITEM_STATE: type('CLEAR_CREATE_POST_ITEM_STATE'),

    UPDATE_POST_ITEM: type('UPDATE_POST_ITEM'),
    UPDATE_POST_ITEM_SUCCESS: type('UPDATE_POST_ITEM_SUCCESS'),
    UPDATE_POST_ITEM_FAIL: type('UPDATE_POST_ITEM_FAIL'),
    CLEAR_UPDATE_POST_ITEM_STATE: type('CLEAR_UPDATE_POST_ITEM_STATE'),

    GET_CATEGORY_LIST: type('GET_CATEGORY_LIST'),
    GET_CATEGORY_LIST_SUCCESS: type('GET_CATEGORY_LIST_SUCCESS'),
    GET_CATEGORY_LIST_FAIL: type('GET_CATEGORY_LIST_FAIL'),

    GET_CATEGORY_ITEM: type('GET_CATEGORY_ITEM'),
    GET_CATEGORY_ITEM_SUCCESS: type('GET_CATEGORY_ITEM_SUCCESS'),
    GET_CATEGORY_ITEM_FAIL: type('GET_CATEGORY_ITEM_FAIL'),
    CLEAR_GET_CATEGORY_ITEM_STATE: type('CLEAR_GET_CATEGORY_ITEM_STATE'),

    CREATE_TAG_ITEM: type('CREATE_TAG_ITEM'),
    CREATE_TAG_ITEM_SUCCESS: type('CREATE_TAG_ITEM_SUCCESS'),
    CREATE_TAG_ITEM_FAIL: type('CREATE_TAG_ITEM_FAIL'),
    CLEAR_CREATE_TAG_ITEM_FAIL: type('CLEAR_CREATE_TAG_ITEM_FAIL'),

    UPDATE_TAG_ITEM: type('EDIT_TAG_ITEM'),
    UPDATE_TAG_ITEM_SUCCESS: type('EDIT_TAG_ITEM_SUCCESS'),
    UPDATE_TAG_ITEM_FAIL: type('EDIT_TAG_ITEM_FAIL'),
    CLEAR_UPDATE_TAG_ITEM_STATE: type('CLEAR_EDIT_TAG_ITEM_STATE'),

    REMOVE_TAG_ITEM: type('REMOVE_TAG_ITEM'),
    REMOVE_TAG_ITEM_SUCCESS: type('REMOVE_TAG_ITEM_SUCCESS'),
    REMOVE_TAG_ITEM_FAIL: type('REMOVE_TAG_ITEM_FAIL'),
    CLEAR_REMOVE_TAG_ITEM_FAIL_STATE: type('CLEAR_REMOVE_TAG_ITEM_FAIL_STATE'),

    GET_TAG_ITEM: type('GET_TAG_ITEM'),
    GET_TAG_ITEM_SUCCESS: type('GET_TAG_ITEM_SUCCESS'),
    GET_TAG_ITEM_FAIL: type('GET_TAG_ITEM_FAIL'),
    CLEAR_GET_TAG_ITEM_STATE: type('CLEAR_GET_TAG_ITEM_STATE'),

    GET_TAG_LIST: type('GET_TAG_LIST'),
    GET_TAG_LIST_SUCCESS: type('GET_TAG_LIST_SUCCESS'),
    GET_TAG_LIST_FAIL: type('GET_TAG_LIST_FAIL'),
    CLEAR_GET_TAG_LIST_STATE: type('CLEAR_GET_TAG_LIST_STATE'),

    REMOVE_IMAGE_FROM_POST: type('REMOVE_IMAGE_FROM_POST'),
    REMOVE_IMAGE_FROM_POST_SUCCESS: type('REMOVE_IMAGE_FROM_POST success'),
    REMOVE_IMAGE_FROM_POST_FAIL: type('REMOVE_IMAGE_FROM_POST fail'),
    CLEAR_REMOVE_IMAGE_FROM_POST_STATE: type('clear REMOVE_IMAGE_FROM_POST state'),
};

export class GetPostListAction implements Action {
    type = ActionTypes.GET_POST_LIST;
    constructor(public payload: any) { }
}
export class GetPostListSuccessAction implements Action {
    type = ActionTypes.GET_POST_LIST_SUCCESS;
    constructor(public payload: any) { }
}
export class GetPostListFailAction implements Action {
    type = ActionTypes.GET_POST_LIST_FAIL;
    constructor(public payload: any) { }
}

export class GetPostItemAction implements Action {
    type = ActionTypes.GET_POST_ITEM;
    constructor(public payload: any) { }
}
export class GetPostItemFailAction implements Action {
    type = ActionTypes.GET_POST_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class GetPostItemSuccessAction implements Action {
    type = ActionTypes.GET_POST_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearGetPostItemStateAction implements Action {
    type = ActionTypes.CLEAR_GET_POST_ITEM_STATE;
    constructor(public payload: any) { }
}

export class RemovePostItemAction implements Action {
    type = ActionTypes.REMOVE_POST_ITEM;
    constructor(public payload: any) { }
}
export class RemovePostItemFailAction implements Action {
    type = ActionTypes.REMOVE_POST_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class RemovePostItemSuccessAction implements Action {
    type = ActionTypes.REMOVE_POST_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearRemovePostItemStateAction implements Action {
    type = ActionTypes.CLEAR_REMOVE_POST_ITEM_STATE;
    constructor(public payload: any) { }
}

export class CreatePostItemAction implements Action {
    type = ActionTypes.CREATE_POST_ITEM;
    constructor(public payload: any) { }
}
export class CreatePostItemFailAction implements Action {
    type = ActionTypes.CREATE_POST_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class CreatePostItemSuccessAction implements Action {
    type = ActionTypes.CREATE_POST_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearCreatePostItemStateAction implements Action {
    type = ActionTypes.CLEAR_CREATE_POST_ITEM_STATE;
    constructor(public payload: any) { }
}

export class UpdatePostItemAction implements Action {
    type = ActionTypes.UPDATE_POST_ITEM;
    constructor(public payload: any) { }
}
export class UpdatePostItemFailAction implements Action {
    type = ActionTypes.UPDATE_POST_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class UpdatePostItemSucccessAction implements Action {
    type = ActionTypes.UPDATE_POST_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearUpdatePostItemStateAction implements Action {
    type = ActionTypes.CLEAR_UPDATE_POST_ITEM_STATE;
    constructor(public payload: any) { }
}

export class GetCategoryListAction implements Action {
    type = ActionTypes.GET_CATEGORY_LIST;
    constructor(public payload: any) { }
}
export class GetCategoryListFailAction implements Action {
    type = ActionTypes.GET_CATEGORY_LIST_FAIL;
    constructor(public payload: any) { }
}
export class GetCategoryListSuccessAction implements Action {
    type = ActionTypes.GET_CATEGORY_LIST_SUCCESS;
    constructor(public payload: any) { }
}

export class GetCategoryItemAction implements Action {
    type = ActionTypes.GET_CATEGORY_ITEM;
    constructor(public payload: any) { }
}
export class GetCategoryItemFailAction implements Action {
    type = ActionTypes.GET_CATEGORY_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class GetCategoryItemSuccessAction implements Action {
    type = ActionTypes.GET_CATEGORY_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearGetCategoryItemStateAction implements Action {
    type = ActionTypes.CLEAR_GET_CATEGORY_ITEM_STATE;
    constructor(public payload: any) { }
}

export class CreateTagItemAction implements Action {
    type = ActionTypes.CREATE_TAG_ITEM;
    constructor(public payload: any) { }
}
export class CreateTagItemFailAction implements Action {
    type = ActionTypes.CREATE_TAG_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class CreateTagItemSuccessAction implements Action {
    type = ActionTypes.CREATE_TAG_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearCreateTagItemStateAction implements Action {
    type = ActionTypes.CLEAR_CREATE_TAG_ITEM_FAIL;
    constructor(public payload: any) { }
}

export class UpdateTagItemAction implements Action {
    type = ActionTypes.UPDATE_TAG_ITEM;
    constructor(public payload: any) { }
}
export class UpdateTagItemFailAction implements Action {
    type = ActionTypes.UPDATE_TAG_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class UpdateTagItemSuccessAction implements Action {
    type = ActionTypes.UPDATE_TAG_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearUpdateTagItemStateAction implements Action {
    type = ActionTypes.CLEAR_UPDATE_TAG_ITEM_STATE;
    constructor(public payload: any) { }
}

export class RemoveTagItemAction implements Action {
    type = ActionTypes.REMOVE_TAG_ITEM;
    constructor(public payload: any) { }
}
export class RemoveTagItemFailAction implements Action {
    type = ActionTypes.REMOVE_TAG_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class RemoveTagItemSuccessAction implements Action {
    type = ActionTypes.REMOVE_TAG_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearRemoveTagItemStateAction implements Action {
    type = ActionTypes.CLEAR_REMOVE_TAG_ITEM_FAIL_STATE;
    constructor(public payload: any) { }
}

export class GetTagItemAction implements Action {
    type = ActionTypes.GET_TAG_ITEM;
    constructor(public payload: any) { }
}
export class GetTagItemFailAction implements Action {
    type = ActionTypes.GET_TAG_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class GetTagItemSuccessAction implements Action {
    type = ActionTypes.GET_TAG_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearGetTagItemStateAction implements Action {
    type = ActionTypes.CLEAR_GET_TAG_ITEM_STATE;
    constructor(public payload: any) { }
}

export class GetTagListAction implements Action {
    type = ActionTypes.GET_TAG_LIST;
    constructor(public payload: any) { }
}
export class GetTagListFailAction implements Action {
    type = ActionTypes.GET_TAG_LIST_FAIL;
    constructor(public payload: any) { }
}
export class GetTagListSuccessAction implements Action {
    type = ActionTypes.GET_TAG_LIST_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearGetTagListStateAction implements Action {
    type = ActionTypes.CLEAR_GET_TAG_LIST_STATE;
    constructor(public payload: any) { }
}

export class RemoveImageFromPostAction implements Action {
    type = ActionTypes.REMOVE_IMAGE_FROM_POST;
    constructor(public payload: any) { }
}
export class RemoveImageFromPostFailAction implements Action {
    type = ActionTypes.REMOVE_IMAGE_FROM_POST_FAIL;
    constructor(public payload: any) { }
}
export class RemoveImageFromPostSuccessAction implements Action {
    type = ActionTypes.REMOVE_IMAGE_FROM_POST_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearRemoveImageFromPostStateAction implements Action {
    type = ActionTypes.CLEAR_REMOVE_IMAGE_FROM_POST_STATE;
    constructor(public payload: any) { }
}

export type Actions =
    | GetPostListAction
    | GetPostListFailAction
    | GetPostListSuccessAction
    | GetPostItemAction
    | GetPostItemFailAction
    | GetPostItemSuccessAction
    | ClearGetPostItemStateAction
    | RemovePostItemAction
    | RemovePostItemFailAction
    | RemovePostItemSuccessAction
    | CreatePostItemAction
    | CreatePostItemFailAction
    | CreatePostItemSuccessAction
    | UpdatePostItemAction
    | UpdatePostItemFailAction
    | UpdatePostItemSucccessAction
    | ClearRemovePostItemStateAction
    | ClearCreatePostItemStateAction
    | ClearUpdatePostItemStateAction
    | GetCategoryListAction
    | GetCategoryListFailAction
    | GetCategoryListSuccessAction
    | GetCategoryItemAction
    | GetCategoryItemFailAction
    | GetCategoryItemSuccessAction
    | ClearGetCategoryItemStateAction
    | CreateTagItemAction
    | CreateTagItemFailAction
    | CreateTagItemSuccessAction
    | ClearCreateTagItemStateAction
    | UpdateTagItemAction
    | UpdateTagItemFailAction
    | UpdateTagItemSuccessAction
    | ClearUpdateTagItemStateAction
    | RemoveTagItemAction
    | RemoveTagItemFailAction
    | RemoveTagItemSuccessAction
    | ClearRemoveTagItemStateAction
    | GetTagItemAction
    | GetTagItemFailAction
    | GetTagItemSuccessAction
    | ClearGetTagItemStateAction
    | GetTagListAction
    | GetTagListFailAction
    | GetTagListSuccessAction
    | ClearGetTagListStateAction
    | RemoveImageFromPostAction
    | RemoveImageFromPostFailAction
    | RemoveImageFromPostSuccessAction
    | ClearRemoveImageFromPostStateAction
